import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { LinkType } from "../types/value/link.js";
import { documentToLinkField } from "./documentToLinkField.js";

var asLink = function asLink(linkFieldOrDocument) {
  if (!linkFieldOrDocument) {
    return null;
  }

  var linkField = // prettier-ignore
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore - Bug in TypeScript 4.9: https://github.com/microsoft/TypeScript/issues/51501
  // TODO: Remove the `prettier-ignore` comment when this bug is fixed.
  "link_type" in linkFieldOrDocument ? linkFieldOrDocument : documentToLinkField(linkFieldOrDocument);

  for (var _len = arguments.length, configObjectOrTuple = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    configObjectOrTuple[_key - 1] = arguments[_key];
  }

  var configObjectOrLinkResolver = configObjectOrTuple[0];
  var config;

  if (typeof configObjectOrLinkResolver === "function" || configObjectOrLinkResolver == null) {
    config = {
      linkResolver: configObjectOrLinkResolver
    };
  } else {
    config = _objectSpread({}, configObjectOrLinkResolver);
  }

  switch (linkField.link_type) {
    case LinkType.Media:
    case LinkType.Web:
      return "url" in linkField ? linkField.url : null;

    case LinkType.Document:
      {
        if ("id" in linkField && config.linkResolver) {
          var resolvedURL = config.linkResolver(linkField);

          if (resolvedURL != null) {
            return resolvedURL;
          }
        }

        if ("url" in linkField && linkField.url) {
          return linkField.url;
        }

        return null;
      }

    case LinkType.Any:
    default:
      return null;
  }
};

export { asLink };